var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8928 6.72323L8 3.61603L11.1088 6.72483L12.9168 4.91683L8 3.05176e-05L3.0848 4.91523L4.8928 6.72323ZM0 8.00003L1.808 6.19203L3.616 8.00003L1.808 9.80803L0 8.00003ZM4.8928 9.27683L8 12.384L11.1088 9.27523L12.9168 11.0824L8 16L3.0848 11.0848L3.0824 11.0824L4.8928 9.27683ZM12.384 8.00003L14.192 6.19203L16 8.00003L14.192 9.80803L12.384 8.00003ZM9.8336 7.99843H9.8352V8.00003L8 9.83523L6.1672 8.00323L6.164 8.00003L6.1672 7.99763L6.488 7.67603L6.644 7.52003L8 6.16483L9.8344 7.99923L9.8336 7.99843Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.7d0286113fd29d2f726220a672ae2c5d.svg";
export { ForwardRef as ReactComponent };